<app-context-menu-heading>Sorting options:</app-context-menu-heading>

<app-context-menu-item
  [withCheckOption]="true"
  title="Title"
  [active]="store.folderOptions().sortBy === 'title'"
  [sortable]="true"
  [reversed]="store.folderOptions().sortOrder === 'desc'"
  (execute)="store.sortFolders('title')"
/>
<app-context-menu-item
  [withCheckOption]="true"
  title="Created Date"
  [active]="store.folderOptions().sortBy === 'createdAt'"
  [sortable]="true"
  [reversed]="store.folderOptions().sortOrder === 'desc'"
  (execute)="store.sortFolders('createdAt')"
/>
<app-context-menu-item
  [withCheckOption]="true"
  title="Updated Date"
  [active]="store.folderOptions().sortBy === 'updatedAt'"
  [sortable]="true"
  [reversed]="store.folderOptions().sortOrder === 'desc'"
  (execute)="store.sortFolders('updatedAt')"
/>

<app-context-menu-divider />

<app-context-menu-item
  [withCheckOption]="true"
  title="Pinned on Top"
  [active]="store.folderOptions().pinnedOnTop"
  (execute)="store.toggleFolderPinnedOnTop()"
/>
<app-context-menu-item
  [withCheckOption]="true"
  title="Flagged on Top"
  [active]="store.folderOptions().flaggedOnTop"
  (execute)="store.toggleFolderFlaggedOnTop()"
/>

<app-context-menu-heading>Filters:</app-context-menu-heading>

<app-stitch-type-context-menu-item
  [withCheckOption]="true"
  title="Stitch"
  [state]="store.folderOptions().stitchedWith"
  (onSelect)="store.setFolderStitchFilter($event)"
/>

<app-context-menu-divider />

<app-context-menu-item
  [withCheckOption]="true"
  title="Flagged"
  [active]="store.folderOptions().flagged"
  (execute)="store.toggleFolderFlaggedFilter()"
/>
<app-context-menu-item
  [withCheckOption]="true"
  title="Pinned"
  [active]="store.folderOptions().pinned"
  (execute)="store.toggleFolderPinnedFilter()"
/>
<app-context-menu-item [withCheckOption]="true" [active]="!!(store.folderOptions().from || store.folderOptions().to)" title="Selected Date">
  <div class="date">
    <div class="date-buttons">
      <div
        class="date-buttons-item"
        [class.selected]="dateButtonSelected() === 'from'"
        [class.active]="fromDate.value"
        (click)="dateButtonSelected.set('from')"
      >
        <app-icon class="date-buttons-item-icon" name="sapphire-events" [size]="16" />
        <span class="date-buttons-item-text">{{ fromDate.value ? (fromDate.value | dateFormat: 'date') : 'After' }}</span>
      </div>
      <div
        class="date-buttons-item"
        [class.selected]="dateButtonSelected() === 'to'"
        [class.active]="toDate.value"
        (click)="dateButtonSelected.set('to')"
      >
        <app-icon class="date-buttons-item-icon" name="sapphire-events" [size]="16" />
        <span class="date-buttons-item-text">{{ toDate.value ? (toDate.value | dateFormat: 'date') : 'Before' }}</span>
      </div>
    </div>

    <app-date-picker-2
      [flush]="true"
      [inputFormControl]="dateButtonSelected() === 'from' ? fromDate : toDate"
      [collapseable]="false"
      [maxDate]="dateButtonSelected() === 'from' && toDate.value"
      [minDate]="dateButtonSelected() === 'to' && fromDate.value"
      [highlightRange]="true"
    />

    @if (fromDate.value || toDate.value) {
      <div class="flex justify-end pt-2">
        <app-button2 appearance="primary-text" size="s" (click)="clearSelectedDate()">Clear</app-button2>
      </div>
    }
  </div>
</app-context-menu-item>
